import React, { Component } from 'react';
import PropTypes from 'prop-types';
import $j from 'jquery';
// import c from 'classnames';
import fontcolors from 'admin/helper/fontColorsForEditor';
import executeHelper from '../LessonComponents/HtmlType/HtmlFamily/redactorHelper';

class AccordionItems extends Component {
  static contextTypes = {
    dispatch: PropTypes.func,
    getFeatureFlag: PropTypes.func
  };

  componentDidMount() {
    const useFilestackFilePicker =
      this.context.getFeatureFlag && this.context.getFeatureFlag('use-filestack');

    executeHelper(useFilestackFilePicker);
    this.initChange = true;
    this.redactorEditor = window.$R(this.textArea, {
      plugins: [
        'alignment',
        'filepicker',
        'fontsize',
        /*  'lineheight', */ 'fontfamily',
        'fontcolor',
        'table'
      ],
      toolbarFixedTopOffset: 47,
      buttons: [
        'html',
        'format',
        'bold',
        'italic',
        'underline',
        'deleted',
        'line',
        'lists',
        'image',
        'file',
        'link',
        'horizontalrule',
        'alignment',
        'filepicker',
        'fontsize',
        /* 'lineheight', */ 'fontfamily',
        'fontcolor',
        'sup',
        'sub'
      ],
      imageResizable: true,
      imagePosition: true,
      imageFloatMargin: '15px',
      focus: false,
      callbacks: {
        synced: this.htmlChanged
      },
      fontcolors
    });
    this.redactorEditor.source.setCode(this.props.item.html);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // console.log(nextProps + 'componentWillReceiveProps');
    if (this.props.item._id !== nextProps.item._id) {
      // this.redactorEditor.destroy();
      this.redactorEditor.source.setCode(nextProps.item.html);
      this.initChange = true;
      // setTimeout(() => this.redactorEditor.insertion.insertRaw(''), 10);
    }
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.item._id !== nextProps.item._id) {
      return true;
    }
    return false;
  }

  componentWillUnmount() {
    $j(this.htmlRef).off('click.external');
  }

  getIfInitChange = () => this.initChange;

  setTextareaRef = ref => (this.textArea = ref);

  // setTextareaRefTest = itemId => (ref) => {
  //   this.textArea = ref;
  //   console.log(ref);
  //   this.id = itemId;
  // };

  htmlChanged = html => {
    if (this.initChange) {
      this.initChange = false;
      return false;
    }

    this.context.dispatch('UPDATE_ITEM_DATA', {
      _id: this.props.item._id,
      html
    });
  };

  renderContent = () => {
    const blockItem = this.props;
    // const item = blockItem.items[0];

    return (
      <textarea
        placeholder="Add content here..."
        ref={this.setTextareaRef}
        id="redactor-placeholder"
        name="redactor-placeholder"
      />
    );
  };

  render() {
    // const editable = true;
    return (
      <div className="block-html">
        <div style={{ paddingTop: '14px' }}>
          <div style={{ fontFamily: 'ProximaNova', fontSize: '14px', color: '#929dae' }}>
            Description
          </div>
          {this.renderContent()}
        </div>
      </div>
    );
  }
}

export default AccordionItems;
